// extracted by mini-css-extract-plugin
export default {"optionCard":"optionCard___Smhr4"};